export enum OnboardingIndividualErrorCodes {
  ONBOARD_FAILED = 'onboard_failed',
  DUPLICATE_EMAIL = 'duplicate_email',
  EXISTING_USER = 'existing_user',
  CREATING_ORG_FAILED = 'creating_org_failed',
  UNABLE_TO_ADD_USER = 'unable_to_add_user',
  ALREADY_ASSOCIATED_USERS = 'already_associated_users',
  FIRST_NAME_REQUIRED = 'first_name_required',
  FIRST_NAME_IS_STRING = 'first_name_is_string',
  MIDDLE_NAME_IS_STRING = 'middle_name_is_string',
  LAST_NAME_REQUIRED = 'last_name_required',
  LAST_NAME_IS_STRING = 'last_name_is_string',
  PASSWORD_REQUIRED = 'password_required',
  PASSWORD_IS_STRING = 'password_is_string',
  COUNTRY_REQUIRED = 'country_required',
  COUNTRY_IS_STRING = 'country_is_string',
  COUNTRY_IS_ISO31661ALPHA2 = 'country_is_ISO31661Alpha2',
  ADDRESS1_IS_STRING = 'address1_is_string',
  ADDRESS2_IS_STRING = 'address2_is_string',
  ADDRESS3_IS_STRING = 'address3_is_string',
  ADDRESS4_IS_STRING = 'address4_is_string',
  CITY_REQUIRED = 'city_required',
  CITY_IS_STRING = 'city_is_string',
  POSTAL_CODE_REQUIRED = 'postal_code_required',
  POSTAL_CODE_IS_STRING = 'postal_code_is_string',
  DOB_REQUIRED = 'dob_required',
  DOB_IS_STRING = 'dob_is_string',
  DOB_IS_DATE_STRING = 'dob_is_date_string',
  EMAIL_REQUIRED = 'email_required',
  EMAIL_INVALID = 'email_invalid',
  EMAIL_VERIFIED_BOOLEAN = 'email_verified_boolean',
  USERNAME_IS_STRING = 'username_is_string',
  PROPERTY_NAME_IS_STRING = 'property_name_is_string',
  PROPERTY_NUMBER_IS_STRING = 'property_number_is_string',
  ORGANISATION_ID_IS_STRING = 'organisation_id_is_string',
  ORGANISATION_ID_IS_UUID = 'organisation_id_is_uuid',
  PHONE_REQUIRED = 'phone_required',
  PHONE_IS_STRING = 'phone_is_string',
  PHONE_IS_VALID = 'phone_is_valid',
  PHONE_VERIFIED_BOOLEAN = 'phone_verified_boolean',
  INVALID_TITLE = 'invalid_title',
  INVALID_PRODUCT_CODE = 'invalid_product_code',
  INVALID_DEPOSIT_AMOUNT = 'invalid_deposit_amount',
  INVALID_SOURCE_OF_FUNDS = 'invalid_source_of_funds',
  INVALID_PURPOSE_OF_FUNDS = 'invalid_purpose_of_funds',
  COUNTY_IS_STRING = 'county_is_string',
  PRODUCT_UNAVAILABLE = 'product_unavailable',
  COMPANY_NOT_FOUND = 'company_not_found',
  COMPANY_NOT_ACTIVE = 'company_not_active',
}
